import { Typography } from "@mui/material";

export function LabeledFormInput(props: Readonly<{ label: string; formInput: React.ReactNode }>) {
	return (
		<>
			<Typography className="!text-[14.5px] !font-[400] !font-[PTSansProNarrow] !text-gray-text" sx={{ mb: 1 }}>
				{props.label}
			</Typography>
			{props.formInput}
		</>
	);
}

export default LabeledFormInput;
